/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import _ from 'lodash';
import { useRef } from 'react';

import Cta from './Cta';
import RichText, { isDeltaEmpty } from './RichText';
import Text from './utilities/Text';
import generateTrackDestination from './utilities/trackDestination';
import Card from '../oc-card-new';
import ChevronLink from '../oc-chevron-link';
import { H3 } from '../oc-h';
import Picture from '../oc-picture';
import WrapperLink from '../oc-wrapper-link';

const ContentLink = styled(ChevronLink)`
  &:before {
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const CMSCard = ({
  img,
  alt,
  attribution,
  icon,
  children,
  prehead,
  heading,
  text,
  linkText,
  url,
  closing,
  socialShare,
  overrideImageURLSwitch,
  overrideImageURL,
  ctaSwitch,
  ctaProps,
  crop,
  ...props
}) => {
  const CtaButtonRef = useRef(null);
  const handleCtaButtonClick = e => {
    if (CtaButtonRef.current) {
      e.preventDefault();
      CtaButtonRef.current?.click();
    }
  };

  const resolvedUrl = overrideImageURLSwitch
    ? overrideImageURL
    : ctaSwitch
      ? CtaButtonRef?.current?.href || '#'
      : url;
  const trackDestination = generateTrackDestination(resolvedUrl);

  return (
    <Card
      img={crop ? Picture.Transform(img, { crop: 'crop', ...crop }) : img}
      alt={alt}
      attribution={attribution}
      icon={icon}
      url={resolvedUrl}
      linkText={linkText}
      socialShare={socialShare}
      ctaSwitch={ctaSwitch}
      handleCtaButtonClick={handleCtaButtonClick}
      data-track="learn-more"
      data-track-destination={trackDestination}
      {...props}
    >
      {!isDeltaEmpty(heading) && (
        <H3 prehead={prehead} tag="h3" font="body">
          <RichText content={heading} inline />
        </H3>
      )}

      <RichText content={text} />

      {ctaSwitch && (
        _.isArray(ctaProps) ? (
          ctaProps?.map(ctaPropItem => (
            <Cta {...ctaPropItem} forwardRef={CtaButtonRef} key={ctaPropItem.url} />
          ))
        ) : (
          <Cta {...ctaProps} forwardRef={CtaButtonRef} />
        )
      )}

      {!ctaSwitch && linkText && url && (
        <ContentLink
          data-track-destination={trackDestination}
          data-track="learn-more"
          title={linkText}
          url={url}
        >
          <Text content={linkText} />
        </ContentLink>
      )}
    </Card>
  );
};

export default CMSCard;
